<template>
  <Bar ref="chartRef" :data="chartData" :options="mergedOptions" />
</template>

<script setup>
import { ref, computed } from 'vue'
import { Bar } from 'vue-chartjs'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js'
import { normalizeChartOptions } from './chartOptions'

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

const props = defineProps({
  chartData: { type: Object, required: true },
  options:   { type: Object, default: () => ({}) },
})

// HorizontalBar was removed in vue-chartjs v5; force indexAxis:'y' to replicate it
const mergedOptions = computed(() => ({ ...normalizeChartOptions(props.options), indexAxis: 'y' }))

const chartRef = ref(null)
defineExpose({ get chart() { return chartRef.value?.chart } })
</script>
